module.exports = __webpack_public_path__ + "img/fi-rr-scissors.b4421bf2.svg";